import { useQuery } from 'react-query';

import { apiClient } from 'src/services/api';
import { queryKeys } from 'src/services/api/constants';
import {type AchievementsResponse} from 'src/services/api/achievements/types';

const ACHIEVEMENTS_PATH = 'api/landlord/achievements';

export const useAchievements = () => {
    return useQuery(
        [queryKeys.achievements],
        async () => {
            return await apiClient(ACHIEVEMENTS_PATH).json<AchievementsResponse>();
        }
    );
};
